<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    label-position="top"
    size="mini"
    :disabled="isView"
  >
    <el-row>
      <el-col :span="11">
        <el-form-item label="企业名称" prop="enterpriseName" class="font-bold">
          <el-input
            v-model="form.enterpriseName"
            placeholder="请输入企业名称"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11" :offset="2">
        <el-form-item label="成立时间" prop="regTime" class="font-bold">
          <el-date-picker
            type="date"
            v-model="form.regTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="11">
        <el-form-item label="注册地址" prop="addressProvince" class="font-bold">
          <el-input
            v-model="form.addressProvince"
            placeholder="请输入注册地址"
          />
        </el-form-item>
      </el-col>
      <el-col :span="11" :offset="2">
        <el-form-item label="归属地" prop="addressArea" class="font-bold">
          <el-select v-model="form.addressArea" placeholder="请选择归属地">
            <el-option v-for="area in areas" :key="area" :value="area" />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="11">
        <el-form-item label="开户行" prop="bankName" class="font-bold">
          <el-input v-model="form.bankName" placeholder="必须为对公账户" />
        </el-form-item>
      </el-col>
      <el-col :span="11" :offset="2">
        <el-form-item label="银行卡号" prop="bankNo" class="font-bold">
          <el-input v-model="form.bankNo" placeholder="必须为对公账户" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="11">
        <el-form-item label="企业联系人" prop="contactsName" class="font-bold">
          <el-input
            v-model="form.contactsName"
            placeholder="请输入企业联系人"
          />
        </el-form-item>
      </el-col>
      <el-col :span="11" :offset="2">
        <el-form-item label="联系人电话" prop="contactsPhone" class="font-bold">
          <el-input
            v-model="form.contactsPhone"
            placeholder="请输入联系人电话"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="企业简介" prop="remark" class="font-bold">
      <el-input
        type="textarea"
        :autosize="{ minRows: 4, maxRows: 8 }"
        v-model="form.remark"
        placeholder="发展历程、主营业务、市场销售等方面基本情况，限500字。"
      ></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
import { updateInfo } from "@/api/enterprise";

export default {
  props: ["info", "isView"],
  data() {
    return {
      areas: [
        "昌邑区",
        "龙潭区",
        "船营区",
        "丰满区",
        "永吉县",
        "蛟河市",
        "桦甸市",
        "舒兰市",
        "磐石市",
      ],
      form: {},
      rules: {
        enterpriseName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
          { max: 255, message: "长度不能超过255", trigger: "blur" },
        ],
        addressProvince: [
          { required: true, message: "请输入注册地址", trigger: "blur" },
          { max: 255, message: "长度不能超过255", trigger: "blur" },
        ],
        regTime: [
          { required: true, message: "成产时间不能为空", trigger: "blur" },
          { max: 255, message: "长度不能超过255", trigger: "blur" },
        ],
        addressArea: {
          required: true,
          message: "归属地不能为空",
          trigger: "blur",
        },
        bankName: [{ max: 255, message: "长度不能超过255", trigger: "blur" }],
        bankNo: [{ max: 255, message: "长度不能超过255", trigger: "blur" }],
        contactsName: [{ required: true, message: "联系人不能为空" }],
        contactsPhone: [
          { required: true, message: "联系人电话不能为空" },
          {
            validator: (rule, value, callback) => {
              if (value && !/^1\d{10}$/.test(value)) {
                callback(new Error("请输入正确的联系人电话"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        remark: { required: true, message: "企业简介不能为空" },
      },
    };
  },
  mounted() {
    this.form = Object.assign({}, this.form, {
      enterpriseName: this.info.enterpriseName,
      enterpriseCode: this.info.enterpriseCode,
      addressProvince: this.info.addressProvince,
      regTime: this.info.regTime,
      addressArea: this.info.addressArea,
      bankName: this.info.bankName,
      bankNo: this.info.bankNo,
      contactsName: this.info.contactsName,
      contactsPhone: this.info.contactsPhone,
      remark: this.info.remark,
    });
  },
  methods: {
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          updateInfo(Object.assign({}, this.info, this.form)).then(() => {
            this.$message.success("保存成功");
            this.$emit("save", this.form);
          });
        }
      });
    },
  },
};
</script>
